module.exports = __webpack_public_path__ + "static/media/market.ae3c1d14.svg";